import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import Avatar from "components/Avatar";
import styles from "../styles.module.scss";
import WizardActions from "../WizardActions";
import { useWizard } from "../WizardContext";

const Step3Recipients = () => {
  const { t } = useTranslation();
  const { settings, patchSettings, members } = useWizard();

  const activeMembers = members.filter((m) => m.Status === 4 && m.UserId);

  const [query, setQuery] = useState("");
  const [pickerOpen, setPickerOpen] = useState(false);

  const selectedIds = settings.ReceiverIds;
  const selectedMembers = activeMembers.filter((m) => selectedIds.includes(m.UserId));
  const filtered = activeMembers.filter(
    (m) =>
      !selectedIds.includes(m.UserId) &&
      (query.trim() === "" ||
        m.Label.toLowerCase().includes(query.trim().toLowerCase()) ||
        (m.Email ?? "").toLowerCase().includes(query.trim().toLowerCase())),
  );

  const handleAdd = (userId: string) => {
    patchSettings({ ReceiverIds: [...selectedIds, userId] });
    setQuery("");
    setPickerOpen(false);
  };

  const handleRemove = (userId: string) => {
    patchSettings({
      ReceiverIds: selectedIds.filter((id) => id !== userId),
    });
  };

  return (
    <>
      <div className={styles.description}>
        Wybierz z Twojego zespołu te osoby, które będą wymienione w formularzu
        kontaktowym tak, aby można było wysyłać przesyłki bezpośrednio do każdej
        z tych osób.
      </div>

      <div className={styles.field}>
        <input
          className={styles.secretariatSearch}
          type="text"
          placeholder={t("contactFormWizard.steps.recipients.searchPlaceholder")}
          value={query}
          onChange={(e) => { setQuery(e.target.value); setPickerOpen(true); }}
          onFocus={() => setPickerOpen(true)}
          onBlur={() => setTimeout(() => setPickerOpen(false), 150)}
        />
        {pickerOpen && filtered.length > 0 && (
          <div className={styles.secretariatDropdown}>
            {filtered.map((m) => (
              <div
                key={m.Id}
                className={styles.secretariatOption}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleAdd(m.UserId);
                }}
              >
                <Avatar name={m.Label} size="small" />
                <div className={styles.memberLabel}>
                  <div className={styles.memberName}>{m.Label}</div>
                  {m.Email && <div className={styles.memberEmail}>{m.Email}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedMembers.length > 0 && (
        <div className={styles.memberList}>
          {selectedMembers.map((m) => (
            <div key={m.Id} className={styles.memberRow}>
              <div className={styles.memberInfo}>
                <Avatar name={m.Label} size="small" />
                <div className={styles.memberLabel}>
                  <div className={styles.memberName}>{m.Label}</div>
                  {m.Email && <div className={styles.memberEmail}>{m.Email}</div>}
                </div>
              </div>
              <IconButton
                size="small"
                onClick={() => handleRemove(m.UserId)}
                aria-label="Usuń"
              >
                <svg viewBox="0 0 24 24" width={18} height={18} fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </IconButton>
            </div>
          ))}
        </div>
      )}

      <WizardActions autonomous />
    </>
  );
};

export default Step3Recipients;
